export default __webpack_public_path__ + "static/media/doc.5c7fbe62.svg";